/* 学士学位申报流程 */ 
import Ajax from "./ajax";
import { jsToFormData } from "@/utils/func";

export const getPatch = (data) => Ajax.get(`/v1-adult-student-get-patch`, data);
export const studentDaGetUserInfo = data => Ajax.get(`v1-adult-student-da-getUserInfo`, data);  // 获取学生学位基础信息
export const studentDaNation = data => Ajax.get(`/v1-adult-student-da-nation`, data); // 民族
export const studentDaPolitical = data => Ajax.get(`/v1-adult-student-da-political`, data); // 获取政治面貌
export const studentDaProDegree = data => Ajax.get(`/v1-adult-student-da-pro-degree`, data);  // 专业学位
export const studentDaPost = data => Ajax.post(`/v1-adult-student-da-post`, jsToFormData(data));  // 学位数据提交

export const studentDaRecord = data => Ajax.get(`/v1-adult-student-da-record`, data);  // 获取申请记录
export const studentDaInfo = data => Ajax.get(`/v1-adult-student-da-info`, data);  // 获取申请记录-详情
